





































































































import { Component, Vue,Prop ,Watch} from "vue-property-decorator";
import _com from "@/assets/js/common";
@Component({
    computed:{
        cardAct(){
            return this.$store.getters["refresh/getCardAct"]
        }
    }
})
export default class cardListModal extends Vue {
    isCardShow: any = false
    browser = _com.browser();
	get cardListData() {
        let cardListData = this.$store.getters["refresh/getCardListData"];
        this.navIndex = cardListData.cardActIndex
        if (!this.cardAllData[cardListData.cardList[this.navIndex].cardActivityNo]) {
            this.$store.dispatch("refresh/getUserCardAsync", {
                cardActivityNo: cardListData.cardList[this.navIndex].cardActivityNo
            }).then(()=>{
                setTimeout(() => {
                    this.$forceUpdate()
                }, 500);
            })	            
        }          
        return cardListData;
	}
	get cardAllData() {
        let cardAllData = this.$store.getters["refresh/getCardAllData"];
        console.log(cardAllData,222222222222222);
      
		return cardAllData;
	} 
	get roomData() {//房间数据
		return this.$store.getters["getRoomDetail/getRoomDetail"];
	}    
	stop(e: any) {
		e.stopPropagation();
	}
    isClick = true;
    getCard(card:any) {
		if (this.isClick) {
			this.isClick = false;
			setTimeout(() => {
				this.isClick = true;
			}, 5000);
		} else {
			return false;
		}        
        this.$store.dispatch("refresh/getCardAsync", {
            actNo: card.cardNo,
            cardActivityNo: card.cardActivityNo,
            sceneId: this.roomData.scene_id
        }).then(()=>{
            card.totalNums += 1
            this.$toast('领取成功')
            setTimeout(()=>{
                this.$forceUpdate()
            },1500)
        },(err)=>{
            this.$toast(err.msg)
        })	        
    }
    conflateCard(card:any){
		if (this.isClick) {
			this.isClick = false;
			setTimeout(() => {
				this.isClick = true;
			}, 5000);
		} else {
			return false;
		}
		let channel = '300000'	
		if (this.browser.ylxdsq) {
			channel = '610003'	
		} else if (this.browser.usqxcx) {
			channel = '610002'	
		} else if (this.browser.ylxd) {
			channel = '600000'
		} else if (this.browser.yzgxd) {
			channel = '400006'
		} else if (this.browser.ule) {
			channel = '200000'
		}                
        this.$store.dispatch("refresh/conflateCardAsync", {
            cardActivityNo: card.actNo,
            ruleCode: card.combineChances[0].ruleCode,
            conflate:true,
            channel:channel
        }).then(()=>{
            this.$toast('卡片合成成功')
            setTimeout(()=>{
                this.$forceUpdate()
            },1500)
        },(err)=>{
            this.$toast(err.message)
            setTimeout(()=>{
                this.$forceUpdate()
            },1500)            
        })
    }
    changeCard(index: number,nav: any){
        this.cardListData.cardActIndex = this.navIndex = index;
        this.$store.dispatch("refresh/setCardListDataAsync",this.cardListData)        
        // if (!this.cardAllData[nav.cardActivityNo]) {
        //     this.$store.dispatch("refresh/getUserCardAsync", {
        //         cardActivityNo: nav.cardActivityNo
        //     }).then(()=>{
        //         setTimeout(() => {
        //             this.$forceUpdate()
        //         }, 500);
        //     })	            
        // }
        let navC:any =this.$refs.cardList
        // let navItem:any = this.$refs[`cardItem3`];
        let navItem:any = this.$refs[`cardItem${this.navIndex}`];
        let left = navItem[0].offsetLeft
        navC.scrollTo({
            left: left-110,
            behavior: "smooth",
        });                  
    }
    goCoupon(coupon: any){
        if (!coupon.listingId) {
            return false
        }
        console.log(this.cardListData.cardList[this.navIndex]);
        let codeType = this.cardListData.cardList[this.navIndex].codeType;
        let code = this.cardListData.cardList[this.navIndex].code;
        let listId = coupon.listingId.split(",")[0];
        let room = this.roomData
		let burialPoint = {
			url: location.href,
			ule_title: '直播间集卡优惠券',
			resource_type: '直播间集卡优惠券',
			resource_name: '直播间集卡优惠券',
			resource_content: coupon.batchName,
			resource_module: coupon.batchName,
			resource_inner_position: 0,
			resource_item_type: '优惠券',
			resource_item_id: coupon.batchId,
			remarks: room.roomNumber,
			resource_forward_url: ''
		}        
        // 邮乐优鲜小程序
        let path:string = ''
        let unionParams = `union_id=1016039300&union_ref=${room.roomNumber}_${room.scene_number}`
		if (this.$route.query.ul_aid) {
			unionParams += `&ul_aid=${this.$route.query.ul_aid}`
		}     
        if (this.$route.query.storeid && this.$route.query.shareId) {
            unionParams += `&storeid=${this.$route.query.storeid}&shareId=${this.$route.query.shareId}`
        }            
		if (this.browser.usqxcx) {
            if (codeType == 1) {//跳转接龙
                path = `/packageA/solitaire/index?activityCode=${code}&listId=${listId}&${unionParams}`;
            } else {//跳详情
                path = `/packageA/item/item?listId=${listId}&${unionParams}`;
            }
			(<any>window).wx.miniProgram.navigateTo({ url:  path })//邮乐优鲜小程序详情页
		} else {
            if (codeType == 1) {//跳转接龙
                if (this.browser.ylxdsq) {
                    if (_com.isIos()) {
                        path = `objc:ulemobile://action&&WebDetailViewController:0&&key:https@@//h5${process.env.VUE_APP_URI_DOMAIN}/yxd/community/ylsq/editGroup/${code}?listId=${listId}&isCheck=1&${unionParams}`;
                    } else if (_com.isAndroid()) {
                        path = `ulemobile://action&&ui.MyBusinessWebView##load_url::https://h5${process.env.VUE_APP_URI_DOMAIN}/yxd/community/ylsq/editGroup/${code}?listId=${listId}&isCheck=1&${unionParams}`;
                    }                    
                } else {
                    path = `//h5${this.domain}/yxd/community/chains/chainsDetail/${code}?listId=${listId}&${unionParams}`;
                }
            } else {
                path = "//h5" + this.domain + "/yxd/community/item/itemPage/" + listId + "?union_id=1016039300&union_ref=" + room.roomNumber + '_' + room.scene_number + '&toSeckillLive=' + this.roomData.roomNumber;
            }            
			location.href = path
        }
        burialPoint['resource_forward_url'] = path
		_com.sendSensorTrack('btnClick', this.roomData, burialPoint)
    }
    isShowRule: Boolean = false;
    showRule(){
        this.isShowRule = !this.isShowRule
    }
	close() {
		this.$store.dispatch('refresh/setIsCardShowAsync', false);
	}
    hideCardList() {
		this.isCardShow = false;
	}
    navIndex: number = 0;
    cardActData: any = {};
	mounted() {
        this.isCardShow = true;
		this.$nextTick(() => {
            setTimeout(() => {
                let nav:any =this.$refs.cardList
                // let navItem:any = this.$refs[`cardItem3`];
                let navItem:any = this.$refs[`cardItem${this.navIndex}`];
                let left = navItem[0].offsetLeft
                nav.scrollTo({
                    left: left-110,
                    behavior: "smooth",
                });            
            }, 300);
		})
	}

}

